import axios from 'axios'

export function fetchData() {
  var offset = -( new Date().getTimezoneOffset()/60 )
  var headers = { headers: { offset: offset } }
  return axios.get('https://www.geld.tech/services-availability-dashboard/api/services/status/', headers).then(response => { return response.data }).catch(error => { /* console.error(error); */ return Promise.reject(error) })
}

export function fetchSearchData(keyword) {
  return axios.get('https://www.geld.tech/services-availability-dashboard/api/services/status/' + keyword).then(response => { return response.data }).catch(error => { /* console.error(error); */ return Promise.reject(error) })
}

export function postPayload(url, payload) {
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
  return axios.post(url, payload).then(response => { return response.data }).catch(error => { /* console.error(error); */ return Promise.reject(error) })
}

export function storeAdminPassword(password) {
  var payload = { password: password }
  return postPayload('https://www.geld.tech/services-availability-dashboard/setup/password/', payload)
}

export function storeGanalytics(uaid) {
  var payload = { uaid: uaid }
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
  return axios.post('https://www.geld.tech/services-availability-dashboard/setup/ganalytics/', payload).then(response => { return response.data }).catch(error => { /* console.error(error); */ return Promise.reject(error) })
}

export function storeServices(services) {
  var payload = { services: services }
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
  return axios.post('https://www.geld.tech/services-availability-dashboard/setup/services/', payload).then(response => { return response.data }).catch(error => { /* console.error(error); */ return Promise.reject(error) })
}

export function authenticate(password) {
  var payload = { password: password }
  return postPayload('https://www.geld.tech/services-availability-dashboard/auth/login/', payload)
}

export function deauthenticate() {
  return postPayload('https://www.geld.tech/services-availability-dashboard/auth/logout/')
}

export function getConfig() {
  return axios.get('https://www.geld.tech/services-availability-dashboard/setup/config/').then(response => { return response.data }).catch(error => { /* console.error(error); */ return Promise.reject(error) })
}
